"use client";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { DropDown } from "../Core/DropDown";
import { useSelector } from "react-redux";
import { BaseURL } from "@/config/apiUrl";
import { useState } from "react";
import { updateUser } from "@/store/auth/authSlice";
import { Patch } from "@/axios/AxiosFunctions";
import { apiHeader } from "@/helper/HelperFunction";
import { Spinner } from "react-bootstrap";

export default function StateSwitcher({ placeholder = "Select State" }) {
  const dispatch = useDispatch();
  const { user, access_token } = useSelector((state) => state.authReducer);
  const { states } = useSelector((state) => state.commonReducer);
  const [selectedState, setSelectedState] = useState(
    user?.defaultState || null
  );
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e) => {
    const url = BaseURL(`users/update-me`);
    let params = {
      defaultState: e?._id,
    };
    setLoading(true);
    const response = await Patch(url, params, apiHeader(access_token));
    if (response) {
      dispatch(updateUser(response?.data?.data));
      window.location.reload();
    }
    setLoading(false);
  };

  return (
    <div>
      <DropDown
        customStyle={{
          paddingBlock: "5px !important",
          minWidth: "150px",
        }}
        indicatorColor="var(--main-color)"
        options={user?.states}
        placeholder={placeholder}
        value={selectedState}
        setter={(e) => {
          setSelectedState(e);
          handleUpdate(e);
        }}
        disabled={loading}
        leftIcon={
          loading ? (
            <Spinner size="sm" />
          ) : (
            <HiOutlineLocationMarker color="var(--text-color)" />
          )
        }
        optionLabel={"name"}
        optionValue={"_id"}
      />
    </div>
  );
}
